export class Watch {
	constructor( node, selector ) {
		this.node     = node;
		this.selector = selector;
		this.trigger  = this.node.dataset.fetch || 'a';
		this.mode     = [ 'pushState', 'replaceState' ].includes( this.node.dataset.fetchMode ) ? this.node.dataset.fetchMode : 'pushState';

		const onClick = (e) => {
			let target = e.target;

			while ( target && target !== node ) {
				if ( target.matches( this.trigger ) && target.href ) {
					e.preventDefault();
					this.fetch( target.href );
					return;
				}

				target = target.parentNode;
			}
		}

		this.node.addEventListener( 'click', onClick );

		if ( this.mode ) {
			// handle back button
			window.addEventListener( 'popstate', () => this.fetch( location.href, false ) );
		}
	}

	async fetch( href, history = true ) {
		try {
			this.node.classList.add( 'is-loading' );

			if ( history && this.mode ) {
				window.history[ this.mode ]( {}, '', href );
			}

			const response = await fetch( href );
			const html     = await response.text();
			const parser   = new DOMParser();
			const doc      = parser.parseFromString( html, 'text/html' );
			const node     = doc.querySelector( this.selector );

			if ( ! node instanceof HTMLElement ) {
				throw new Error( 'target node not found' );
			}

			this.node.innerHTML = node.innerHTML;
			this.node.dispatchEvent( new CustomEvent( 'wdg:fetch:refresh', { bubbles: true, detail: this } ) );
		} catch ( fault ) {
			console.error( href, fault );
			location.href = href;
		} finally {
			this.node.classList.remove( 'is-loading' );

			if ( this.node.getBoundingClientRect().top < 0 ) {
				this.node.scrollIntoView( { behavior: 'smooth' } );
			}
		}
	}
}

export function watch( selector = '[data-fetch]' ) {
	const nodes = Array.from( document.querySelectorAll( selector ) );

	if ( nodes.length > 0 ) {
		if ( nodes.length > 1 ) {
			console.error( 'Multiple nodes of the same selector are not supported. Please use something unique.' );
			return;
		}

		return new Watch( nodes[0], selector );
	}
}

document.addEventListener( 'DOMContentLoaded', () => watch() );
